/**
 * Vuex "member" module (registered as `user` in the root store).
 *
 * Aggregates the user-search/reputation-history store slice: state
 * (store.js), actions (operations.js), getters (selectors.js), and
 * mutations (updates.js).
 */
import state from "./store";
import mutations from "./updates";
import getters from "./selectors";
import actions from "./operations";

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
};
